/**
 * Ministry photography used across the public sections. Real gatherings of the
 * FWM family — never icon glyphs — so every hero shows people, not texture.
 * Artwork uploaded in the admin always wins over these.
 */
const CDN = 'https://static.prod-images.emergentagent.com/jobs/c64a2fea-6612-4c37-b58b-aec60e45aaae/images';

export const FWM_IMAGERY = {
  // Full-bleed heroes
  heroHome: `${CDN}/47aabb5030bc1ea7eb8bdcdd209a82cb1dd0f40361bcef5573700b9a1e79ad73.jpeg`,
  heroEvents: `${CDN}/c322a7a6fa1052dcc481451756eb02b22a315fab08d95668ecc22251eddaf4a8.jpeg`,
  heroGiving: `${CDN}/09b02f0f8c2daa9f38dd6bfc55ebd7388c56ebede3c3dc98407c133aaa68f511.jpeg`,
  heroChurches: `${CDN}/9aaef1762194e1e590a399f01310b7e4e185f15392736b84df86bef97c31c1af.jpeg`,
  // Card and section imagery
  teaching: `${CDN}/f0b139eda79af388158130752336894e181fc7b47ae4fcd1dd05962bee7aa3b6.jpeg`,
  choir: `${CDN}/43345725a4413ccfc20a884f2e14c2bbcae54345628ae6887f7e3e8bc4834cd4.jpeg`,
  prayer: `${CDN}/3b82fe136449dc3ea0c8a75e0f6a4d2ee9c789c22e2a1b369f3522e500a9457c.jpeg`,
  youth: `${CDN}/8cacfae51497daca0e3c42636ba929258713f12c2a5eb3d852b72d8482a3734b.jpeg`,
  school: `${CDN}/dbcdfc2b6f7cd6e34feae20a737eaba251293984f46004718f630e31767e3021.jpeg`,
  offering: `${CDN}/fb3ed7947949c9c920899487bd32a2441331094c07c7865d7f5aa004baf37fc5.jpeg`,
};

// Names the sections have always used, now pointing at FWM's own photography.
FWM_IMAGERY.congregation = FWM_IMAGERY.heroHome;
FWM_IMAGERY.worshipNight = FWM_IMAGERY.choir;
FWM_IMAGERY.gathering = FWM_IMAGERY.heroEvents;
FWM_IMAGERY.churchBuilding = FWM_IMAGERY.heroChurches;
FWM_IMAGERY.handsTogether = FWM_IMAGERY.prayer;
FWM_IMAGERY.openHands = FWM_IMAGERY.offering;

/** A stable photo for a record with no uploaded artwork, varied by index. */
export const FWM_CARD_ART = [
  FWM_IMAGERY.choir, FWM_IMAGERY.teaching, FWM_IMAGERY.heroChurches,
  FWM_IMAGERY.youth, FWM_IMAGERY.prayer, FWM_IMAGERY.school,
];

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Uploaded artwork can be relative, absolute, or a leftover test URL. */
export const resolveImage = (url) => {
  if (!url) return null;
  const s = String(url);
  if (s.includes('example.com') || s.includes('test.com') || s.includes('placeholder')) return null;
  if (s.startsWith('http')) return s;
  return `${API_URL}${s}`;
};
